import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { ClientData } from "../../providers/client";

@Component({
  selector: "app-select-categories",
  templateUrl: "select-categories.html",
})
export class SelectCategoriesComponent implements OnInit {

  @Input() public clientId: string;
  @Input() public currentCategories: string[] = [];
  @Output() public select = new EventEmitter();

  public categories$: Observable<any[]>;
  public categoriesSelect: any;

  constructor(
    private clientData: ClientData,
  ) { }

  public selected(ctgs) {
    this.select.emit(ctgs);
  }

  public ngOnInit() {
    this.categories$ = this.clientData.getClientCategoriesActive(this.clientId);
  }

}



// WEBPACK FOOTER //
// ./src/components/select-categories/select-categories.ts